<div class="container">
    <h2 id="timer-display">{{#if countdown}}{{t TimeLeft}} {{countdown}}{{else}}{{t Time}}: 0{{/if}}</h2>
</div>